import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'
import Units from './Units'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';


class Unit extends Component {

    constructor(){
        super();
        this.addUnit = this.addUnit.bind(this);
        this.removeUnit = this.removeUnit.bind(this);
        this.state = {
            userId:"",
            user :{},
            errorMsg : "",
            unitsList :{}
        };
    }
    
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId:data.key,
                        user:data.val()
                      });

                    }.bind(this));
            }else{
              this.props.history.push("/login");
            }
        });

        var units = ref.child("Units")
            units.on("value", function(snap){
                this.setState({
                    unitsList : snap.val()
                })
            }.bind(this))   
    }

    componentWillUnmount(){
      this.listener()
    }

    addUnit(e){
        e.preventDefault();
        if(this.unit.value){
            let unitDetails = {
                unit : this.unit.value
            }
            ref.child("Units").push(unitDetails)
                .then(alert("New Unit has been added"))
                .catch(function(error){
                    this.setState({
                        errorMsg : "Opps"+error.code
                    })
                })
        }else{
            this.setState({
                errorMsg:"Please Fill up the both fields"
            })
        }
        this.unitForm.reset();
    }

    removeUnit(unitId){
        let unitsList = this.state.unitsList;
        let unit = {}
        if(window.confirm("Do you really want to remove this Unit")===true){
            Object.keys(unitsList).map(key =>{
                unit = unitsList[unitId] 
                if(unit === unitsList[key]){
                    let statusUpdate ={
                        unit : null
                    }
                    ref.child("Units").child(unitId).update(statusUpdate).then(()=>{
                        alert("Unit successfully deleted ")
                    })// end of update in the firebase
                } // end of condition  
            } ) //end of loop
        }// end of window confirm
    }

    render() {
      
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Unit" />
                            <div className="block">
                                <form className="form-horizontal form-bordered" ref={(input) => {this.unitForm=input}}  onSubmit={(e)=>this.addUnit(e)}>
                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="category-name">Unit</label>
                                        <div className="col-md-4">
                                            <input className="form-control"  ref={(input) => {this.unit=input}} type="text" />
                                        </div>
                                        <div className="col-md-4">
                                            <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-floppy-o"></i> Add Unit</button>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        {
                                            this.state.errorMsg &&
                                        <label className="col-md-4 control-label" htmlFor="error-msg">{this.state.errorMsg}</label>
                                        }
                                    </div>                                    
                                </form>
                            </div>
                                <div className="table-responsive unitListWrapper">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Unit</th>
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { Object.keys(this.state.unitsList).map(key => <Units key={key} index={key} details ={this.state.unitsList[key]}
                                                removeUnit={this.removeUnit}/>) }
                                        </tbody>
                                    </table>
                                </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}

export default Unit;



// WEBPACK FOOTER //
// ./src/components/Unit.js